import React from "react";
import FormWrapper from "./Components/Form-Wrapper";
function App() {
  return (
    <div className="App">
      <FormWrapper />
    </div>
  );
}
// Blue":"3e7cb1","Iceberg":"81a4cd","Marigold":"e9a11b","Dark Liver Horses":"593837","Raw Umber":"7c6354"}

export default App;
